import { Navigate, Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import {
  getInstagramRoutes,
  protected_routes,
} from "./routes";
import Home from "./Sidebar/Home";
import { SnackbarProvider } from "notistack";
import {
  INSTAGRAM,
  LEGACY_REDIRECTS,
} from "./OnboardingPage/routeNames";
import HomeDashboard from "./Sidebar/HomeDashboard";
import InstagramWrapper from "./Integrations/Instagram/InstagramWrapper";
import theme from "./theme";
import { ThemeProvider } from "@mui/material";
import { LayoutProvider } from "./CustomHooks.js/LayoutContext";
import LoginPage from "./LoginPage/LoginPage";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LayoutProvider>
        <SnackbarProvider
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          maxSnack={3}
          autoHideDuration={3000}
          hideIconVariant={true}
          style={{
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
            fontWeight: 500,
          }}
        >
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<Home />}>
                <Route path="/" element={<HomeDashboard />} />

                {/* Instagram product pages — flat slugs; InstagramWrapper
                    provides the account-switcher chrome via a pathless layout
                    route so the 3 pages share it without living under /instagram. */}
                <Route element={<InstagramWrapper />}>
                  {getInstagramRoutes().map((r) => (
                    <Route key={r.path} path={r.path} element={r.component} />
                  ))}
                </Route>

                {/* Non-product protected routes (integrations, settings, etc.) */}
                {protected_routes
                  .filter((route) => route.path !== INSTAGRAM)
                  .map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.component}
                    />
                  ))}

                {/* Legacy URL redirects — every historical path maps to the
                    current canonical slug. Add new entries in routeNames.js. */}
                {LEGACY_REDIRECTS.map(({ from, to }) => (
                  <Route
                    key={from}
                    path={from}
                    element={<Navigate to={to} replace />}
                  />
                ))}
              </Route>
            </Routes>
          </BrowserRouter>
        </SnackbarProvider>
      </LayoutProvider>
    </ThemeProvider>
  );
}

export default App;
